import { api } from './api';
import { selectors } from './selectors';
import { slice } from './slice';

interface INotificationStore {
  actions: typeof slice.actions;
  selectors: typeof selectors;
  api: typeof api;
}

const notificationStore: INotificationStore = {
  actions: slice.actions,
  selectors,
  api,
};

export { notificationStore };
